// @flow
import { openSearchResultActionPanel } from "components/SearchResultActionPanel";
import { openGeoPointActionPanel } from "components/GeoPointActionPanel";
import { searchRouteWithItem } from "components/ItemUriLink";
import { check_isView } from "containers/ActionPanel";
import CommandActionHandler from "components/CommandActions";
import { usePostMessageHandler } from "./Handler";

const useDefaultPostMessageHandler = (history) =>
    usePostMessageHandler({
        search: (data) =>
            history.push(searchRouteWithItem(/*searchItem*/ data)),
        "geo-info": (data) => {
            /* istanbul ignore else */
            if (data.row) {
                openSearchResultActionPanel({
                    row: {
                        ...data.row,
                        targetView: "searchresult",
                    },
                });
            } else if (check_isView({ views: ["upload"] })) {
                openGeoPointActionPanel({
                    location: data,
                });
            }
        },
        exec: (data) => CommandActionHandler(data.actionId, data.props),
    });

export { usePostMessageHandler, useDefaultPostMessageHandler };
